export enum DataTypes {
    INTEGER = 'integer',
    FLOAT = 'float',
    BOOLEAN = 'boolean'
}
